import config from '../../../config'

export const encodeQueryValue = (value) => {
	if(typeof value === 'array') {
		return value.join(config.queryParamSeperator);
	}
	else {
		return value.toString();
	}
}

export default encodeQueryValue;